import { render, staticRenderFns } from "./ReopenRequestModal.vue?vue&type=template&id=7dfcb7c6&scoped=true&"
import script from "./ReopenRequestModal.vue?vue&type=script&lang=js&"
export * from "./ReopenRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./ReopenRequestModal.vue?vue&type=style&index=0&id=7dfcb7c6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfcb7c6",
  null
  
)

export default component.exports